import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { injectIntl } from 'gatsby-plugin-intl'
import { ImageHighlight } from './image-highlight'
import { QuoteHighlight } from './quote-highlight'

import './highlights.scss'

const Highlights = ( { intl } ) => {
  const assets = useStaticQuery(
    graphql`
      query assets {
        highlight1: file( relativePath: { eq: "home/tokstok.jpg" } ) {
          ...squareImage
        },
        highlight2: file( relativePath: { eq: "home/conect-car.jpg" } ) {
          ...squareImage
        },
        highlight3: file( relativePath: { eq: "home/stoodi.jpg" } ) {
          ...squareImage
        },
        highlight4: file( relativePath: { eq: "home/basement.jpg" } ) {
          ...squareImage
        },
        highlight5: file( relativePath: { eq: "home/heineken.jpg" } ) {
          ...squareImage
        }, 
        highlight6: file( relativePath: { eq: "home/avon.jpg" } ) {
          ...rectangleImage
        },
        highlight7: file( relativePath: { eq: "home/laureate.jpg" } ) {
          ...rectangleImage
        },
        highlight8: file( relativePath: { eq: "home/eadbr.jpg" } ) {
          ...squareImage
        },
        highlight9: file( relativePath: { eq: "home/livelo.jpg" } ) {
          ...rectangleImage
        },
      }
    `
  )

  return (
    <div id="cases" className="highlights">
      <h2 className="title hidden">{ intl.formatMessage( { id: "highlights.title" } ) }</h2>
      <div className="highlights-list">

        {/* <ImageHighlight domain="saint" image={ assets.highlight9 } /> */}
<div className="highlights-list left">

        <ImageHighlight domain="avon" image={ assets.highlight6 } />
        <ImageHighlight domain="tokstok" image={ assets.highlight1 } />
</div>
<div className="highlights-list right">

        <ImageHighlight domain="heineken" image={ assets.highlight5 } />
        <ImageHighlight domain="livelo" image={ assets.highlight9 } />
        </div>

    <div className="highlights-list single">
        <QuoteHighlight domain="tokstok" />
</div>
<div className="highlights-list left">
        <ImageHighlight domain="laureate" image={ assets.highlight7 } />
                <ImageHighlight domain="basement" image={ assets.highlight4 } />

</div>

<div className="highlights-list middle">
        <ImageHighlight domain="eadbr" image={ assets.highlight8 } />
        <ImageHighlight domain="conectcar" image={ assets.highlight2 } />
        <ImageHighlight domain="stoodi" image={ assets.highlight3 } />
        </div>
      </div>
    </div>
  )
}

const injected = injectIntl( Highlights );
export { injected as Highlights }
